export default __webpack_public_path__ + "static/media/link.2975309a.svg";